<div class="app-titulo-pagina">
    <span>Vales Presentes</span>
</div>

<div class="container app-valepresente-container">
    <div class="col-xs-12 col-md-8 col-md-offset-2">
        <ol class="breadcrumb text-left">
            <li>
                <a (click)="router.navigate(['/valepresente/parceiros'])"
                   class="app-texto-cor-azul breadcrumb-item">Parceiros</a>
            </li>
            <li class="active breadcrumb-item">{{ mainService.valePresenteService.parceiro.nome }}</li>
        </ol>
        <a (click)="router.navigate(['/valepresente/cesta'])"
           class="btn app-btn-best">
           <i class="fa fa-cart-arrow-down"></i>
        </a>
    </div>

    <h4  class="app-margem">SELECIONE O VALOR E A QUANTIDADE DESEJADA:</h4>

    <div class="col-xs-12 col-md-8 col-md-offset-2 app-vale-presente-bordas">
        <div class="col-xs-12 col-sm-8 col-md-6 app-borda-divisora">
            <div class="col-xs-6">
                <img [src]="mainService.valePresenteService.parceiro.logotipo"
                     [alt]="mainService.valePresenteService.parceiro.nome">
            </div>
            <div class="col-xs-6 app-texto-cor-chumbo text-left">
                <strong>CARTÃO<br>PRESENTE</strong>
                <div class="text-center app-politica-troca">
                    POLÍTICA DE<br>USO
                </div>
            </div>
            <div [innerHtml]="mainService.valePresenteService.parceiro.valePresentePoliticaTroca" class="col-xs-12 text-left app-valepresente-politica app-texto-cor-chumbo">
            </div>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-6">
            <div class="text-left">Selecione o modelo desejado: </div>
            <div class="col-xs-12">
                <div *ngIf="!mainService.valePresenteService.parceiroVitrine"
                     class="text-center">
                    <i class="fa fa-spinner fa-pulse fa-4x"></i>
                </div>
                <div *ngIf="mainService.valePresenteService.parceiroVitrine">
                  <div
                      class="app-parceiro-valepresente"
                      *ngFor="let valePresente of mainService.valePresenteService.parceiroVitrine"
                      [ngClass]="{'app-parceiro-valepresente-selecionado': isSelecionado(valePresente)}"
                      (click)="selecionar(valePresente)">
                      <div *ngIf="valePresente.isVariavel" id="valePresenteModelo-{{ valePresente.modelo }}">
                          {{ valePresente.modelo }}
                      </div>
                      <div *ngIf="!valePresente.isVariavel" id="valePresenteValor-{{ valePresente.valor|number:'2.0' }}">
                          <span style="font-size: 12px;">R$</span>
                            {{ valePresente.valor|number:'2.0' }}
                      </div>
                      <div style="font-size: 10px;">
                        {{ valePresente.virtual ? 'Vale Virtual' : 'Vale Físico' }}
                      </div>
                  </div>
                </div>
            </div>
            <div class="col-xs-12 text-left"
                 *ngIf="valePresente && valePresente.isVariavel">
               
                <hr>

                <div *ngIf="valePresente.valorVariavelMinimo !== 0 ||
                           valePresente.valorVariavelMaximo !== 0 ||
                           valePresente.valorVariavelMultiplo !== 0"
                     class="alert alert-warning" 
                     role="alert"
                >
                    <small *ngIf="valePresente.valorVariavelMinimo !== 0">
                        O valor deve ser no mínimo de R$ {{ valePresente.valorVariavelMinimo| number:'1.2-2' }}<br>
                    </small>
                    <small *ngIf="valePresente.valorVariavelMaximo !== 0">
                        O valor deve ser no máximo de R$ {{ valePresente.valorVariavelMaximo| number:'1.2-2' }}<br>
                    </small>
                    <small *ngIf="valePresente.valorVariavelMultiplo !== 0">
                        O valor deve ser múltiplo de R$ {{ valePresente.valorVariavelMultiplo| number:'1.2-2' }}<br>
                    </small>
                </div>

                <div class="form-group">
                    <label for="valor">Digite o valor desejado:</label>

                    <div class="input-group">
                        <div class="input-group-addon app-btn-best" style="cursor:text;">R$</div>
                        <input type="text"
                               class="form-control"
                               id="valor"
                               [(ngModel)]="valePresente.valor"
                               uiMoeda>
                        <span class="input-group-btn">
                            <button class="btn app-btn-best"
                                    *ngIf="!valePresente.isVariavel" 
                                    (click)="add()"
                                    id="btn-adicionar-valor">
                                <i class="fa fa-shopping-basket"></i> Adicionar
                            </button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 text-left"
                 *ngIf="valePresente">
                <hr>
                <div class="form-group">
                    <label for="quantidade">Digite a quantidade desejada:</label>
                    <br>
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            id="quantidade"
                            name = "quantidade"
                            UiNumeros
                            [(ngModel)]="quantidade">
                        <span class="input-group-btn">
                            <button class="btn app-btn-best" 
                                    (click)="add()"
                                    id="btn-adicionar">
                                <i class="fa fa-shopping-basket"></i> Adicionar
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="clearfix"></div>


// WEBPACK FOOTER //
// ./src/app/vale-presente/vitrine/vitrine.component.html